module.exports = __webpack_public_path__ + "static/media/calendar-icon.8a91aaa0.svg";